import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFilters = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M4.75 7a.75.75 0 0 0 0 1.5zm14.5 1.5a.75.75 0 0 0 0-1.5zm-14.5 0h14.5V7H4.75zM6.75 11a.75.75 0 0 0 0 1.5zm10.5 1.5a.75.75 0 0 0 0-1.5zm-10.5 0h10.5V11H6.75zM8.75 15a.75.75 0 0 0 0 1.5zm6.5 1.5a.75.75 0 0 0 0-1.5zm-6.5 0h6.5V15h-6.5z"
    />
  </svg>
);
export default SvgFilters;
